import { apiRequest } from '../utils/api';

const BASE = '/api/v1/bookings/cart/items';

export const fetchBookingCart = () => apiRequest(BASE, { method: 'GET' });

export const addBookingCartItems = (items) =>
  apiRequest(BASE, {
    method: 'POST',
    body: JSON.stringify({ items }),
  });

export const updateBookingCartItem = (cartItemId, item) =>
  apiRequest(`${BASE}/${cartItemId}`, {
    method: 'PATCH',
    body: JSON.stringify(item),
  });

export const removeBookingCartItem = (cartItemId) =>
  apiRequest(`${BASE}/${cartItemId}`, { method: 'DELETE' });

export const clearBookingCart = () =>
  apiRequest(BASE, { method: 'DELETE' });
